module.exports = __webpack_public_path__ + "static/miami-marketta-7f00c7f6eb4547ab80a65bfda24ed61c.jpg";